var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login"}},[_c('Hero',{attrs:{"heroImage":"./img/samuel-zeller-367971-unsplash.jpg"}}),_c('LoginForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }